import React, { forwardRef } from 'react';
import Highcharts from 'highcharts';
import { commonSettings } from '../charts.constants';
import { theme } from '../../../../theme/theme';
import { useChartSettings } from '../hooks/useChartSettings';
import { Chart } from '../Chart';
import { RefObjectForHighchartsReact } from '../Chart.types';

const chartSettings: Highcharts.Options = {
  ...commonSettings,

  chart: {
    type: 'pie',
    margin: [0, 0, 0, 0],
    spacingTop: 0,
    spacingBottom: 0,
    spacingLeft: 0,
    spacingRight: 0,
    style: {
      fontFamily: theme.fontFamily,
    },
  },

  title: {
    text: '',
    useHTML: true,
    floating: false,
    verticalAlign: 'middle',
    align: 'center',
    margin: 0,
    style: {
      fontFamily: theme.fontFamily,
      fontWeight: `${theme.fontWeights['500']}`,
      fontSize: `${theme.fontSizes.h4}px`,
    },
  },

  tooltip: {
    ...commonSettings.tooltip,
    enabled: false,
  },

  plotOptions: {
    pie: {
      slicedOffset: 0,
      enableMouseTracking: false,
      innerSize: '84%',
      borderWidth: 0,
      borderRadius: 0,
      dataLabels: {
        enabled: false,
      },
      states: {
        hover: {
          enabled: false,
        },
      },
    },
  },
};

type Data = 'data';

interface PieChartData {
  name: string;
  y: number;
  color?: string;
}

export type PieChartSeries = Record<Data, PieChartData[]>[];

interface PieChartProps {
  series: PieChartSeries;
  customSettings?: Record<string, any>;
  title?: string;
}

export const PieChart = forwardRef<RefObjectForHighchartsReact, PieChartProps>(
  ({ series, customSettings = {}, title }, ref) => {
    const settings = useChartSettings({
      series,
      settings: { ...chartSettings, title: { ...chartSettings.title, text: title } },
      customSettings,
    });

    return <Chart ref={ref} options={settings} />;
  },
);
